export const SINGLE_DATASET_INPUT_STEP_DATA_NAME = 'Input dataset';
export const SINGLE_DATASET_OUTPUT_STEP_DATA_NAME = 'Output dataset';
export const SINGLE_DATASET_SAMPLED_OUTPUT_STEP_DATA_NAME = 'Sampled output dataset';
export const SINGLE_CHART_OUTPUT_STEP_DATA_NAME = 'Output chart';

/**
 * Step data names for an INITIALIZE_DATASET step.
 * Keep in sync with `initialize_dataset_step_shapes.py`.
 */
export enum InitializeDatasetStepDataName {
  DATASET = 'Dataset',
}

/**
 * Step data names for an NOTEBOOK_TABLE_DATASET step.
 * Keep in sync with `notebook_table_dataset_step_shapes.py`.
 */
export enum NotebookTableDatasetStepDataName {
  DATASET = 'Dataset',
}

/**
 * Step data names for a SAVE_TO_RESULTS step.
 * Keep in sync with `save_to_results_step_shapes.py`.
 */
export enum SaveToResultsStepDataName {
  INPUT_DATASET = 'Input dataset',
  SAVED_RESULTS = 'Saved results',
  ROWS_WITH_ERRORS = 'Rows with errors',
}

/**
 * Step data names for a SEND_TO_DOCUMENT step.
 */
export enum SendToDocumentStepDataName {
  INPUT_SAVED_RESULTS = 'Input saved results',
  INPUT_DATASETS = 'Input datasets',
  INPUT_CHARTS = 'Input charts',
}

/**
 * Step data names for a THIRD_PARTY step.
 * Keep in sync with `third_party_step_shapes.py`.
 */
export enum ThirdPartyStepDataName {
  INPUT_DATASET = 'Input dataset',
  OUTPUT_DATASETS = 'Output datasets',
  OUTPUT_FILES = 'Output files',
}

/**
 * Step data names for a PROCEDURE_RUN_DATA_FRAMES step.
 * Keep in sync with procedure_run_data_frames_step_shapes.py
 */
export enum ProcedureRunDataFramesStepDataName {
  CONDITION_REPLICATE_CONFIRMATION = 'CONDITION_REPLICATE_CONFIRMATION',
  DATA_PARAMETER_ACTUAL = 'DATA_PARAMETER_ACTUAL',
  MATERIAL_PARAMETER_CONFIRMATION = 'MATERIAL_PARAMETER_CONFIRMATION',
  RESULTS = 'RESULTS',
  ENTITIES = 'ENTITIES',
}

export enum RegressionStepDataName {
  MODEL_OUTPUT = 'Model output',
  MODEL_VARIABLES = 'Model variables',
}

export enum RegressionInterpolationInputStepDataName {
  INPUT_DATASET = 'Input dataset',
  MODEL_VARIABLES = 'Model variables',
}
